var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxbolduserReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_user-receive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-receive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.91 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000104676301880688976540000016276288763125434253_",
    className: "st1",
    d: "M0,19.5C0,19.8,0.2,20,0.5,20h17.2 c0.3,0,0.5-0.2,0.5-0.5c0-4.1-4.1-7.5-9.1-7.5S0,15.4,0,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.1,0C7.7,0,6.4,0.6,5.5,1.5S4.1,3.7,4.1,5c0,0.9,0.4,2.2,0.7,2.6c0.2,0.3,0.6,0.8,1,1.1 c0.9,0.8,2,1.3,3.3,1.3c1.8,0,3.4-1,4.3-2.4c0.3-0.4,0.5-0.9,0.6-1.4c0.1-0.5,0.1-0.8,0.1-1.2c0-1.3-0.5-2.5-1.3-3.3 C11.9,0.6,10.6,0,9.1,0z M9.6,7.3L9.6,7.3l1.2-1.2c0.3-0.4,0.1-0.8,0-0.9C10.7,5.1,10.5,5,10.3,5C10.2,5,10,5.1,9.9,5.2L9.7,5.4 V3.1c0-0.4-0.3-0.6-0.6-0.6c-0.4,0-0.6,0.3-0.6,0.6v2.3L8.3,5.2C7.9,4.9,7.6,5,7.4,5.2c-0.2,0.2-0.3,0.6,0,0.9l1.2,1.2 C8.6,7.3,9.1,7.8,9.6,7.3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxbolduserReceive);
export default __webpack_public_path__ + "static/media/vuesaxbolduser-receive.70698d57e7e7ea795b41dd19232b66b1.svg";
export { ForwardRef as ReactComponent };